module.exports = __webpack_public_path__ + "img/selectSelected.e9deca93.png";